import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'TV',
    name: 'Rycerz Kajdan',
    id: 'KnightOfShackles',
    health: 70,
    difficulty: 4,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'TV',
    name: 'Panna Cierni',
    id: 'MaidenOfThorns',
    health: 80,
    difficulty: 4,
    expeditionRating: 3,
    additionalInfo: '',
  },
]
